import { AIGeneratedField, AIGeneratedFieldChoice } from '@/redux/slices/formAIGenerationSlice'
import { FieldClass } from '@/typings/domain'
import { nanoid } from '@reduxjs/toolkit'
import { SCORABLE_CUSTOMIZED_TYPES_MAP } from './buildField/examSettingBuilder'

export default function fixAIGeneratedField<T extends AIGeneratedField>(field: T) {
  const fixedField = { ...field }
  if (SCORABLE_CUSTOMIZED_TYPES_MAP[fixedField.type] && fixedField.examSetting) {
    if (!fixedField.customizedType) {
      fixedField.customizedType = SCORABLE_CUSTOMIZED_TYPES_MAP[field.type]![0]
    }

    if (
      fixedField.customizedType &&
      !SCORABLE_CUSTOMIZED_TYPES_MAP[fixedField.type]!.includes(fixedField.customizedType)
    ) {
      fixedField.customizedType = SCORABLE_CUSTOMIZED_TYPES_MAP[fixedField.type]![0]
    }
  }

  if (Array.isArray(fixedField.choices)) {
    fixedField.choices = fixChoices(fixedField.choices)
  }

  if (fixedField.type === FieldClass.GoodsField) {
    fixedField.customizedType = 'WithoutImagesGoodsField'
  }

  return fixedField
}

function fixChoices(choices: AIGeneratedFieldChoice[]): AIGeneratedFieldChoice[] {
  return choices
    .map(choice => {
      if (!choice.name || !choice.value) {
        choice = {
          ...choice,
          name: choice.name || choice.value || '',
          value: nanoid(4),
        }
      }
      return { ...choice, subChoices: choice.subChoices ? fixChoices(choice.subChoices) : undefined }
    })
    .filter(choice => !!choice.name)
}
